import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { isDataExclusion } from '../../adjustment-type';

export class DescriptionColumn extends ProjectionGridBaseColumn {
  constructor(option) {
    const title = _TL_('Description');
    super({
      name: 'Description',
      title,
      i18n: option.i18n,
      property: 'Description',
      sortable: 'Description',
      helpId: isDataExclusion(option.adjustmentType) ? 'pop_BA_DataExclusions_Description' : 'pop_BA_SeasonalityAdjustments_Description',
      helpAriaLabel: option.i18n.getString(_TL_('Click to learn more about {{item}}'), { item: option.i18n.getString(title) }),
    });
  }
}
